import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { RootState } from '../..'
import { CourseContentSelection } from './types'

const initialState: CourseContentSelection | null = null

const courseContentSelectionSlice = createSlice({
    name: 'courseContentSelection',
    initialState,
    reducers: {
        setCourseContentSelection: (state, action: PayloadAction<CourseContentSelection>) => {
            return action.payload
        },
        resetCourseContentSelection: () => {
            return null
        }
    }
})

export const { setCourseContentSelection, resetCourseContentSelection } = courseContentSelectionSlice.actions

export const courseContentSelectionSelector = (state: RootState) => state.elevateCourses.courseContentSelection

export default courseContentSelectionSlice.reducer 